// extracted by mini-css-extract-plugin
export default {"floatLabel":"style_floatLabel__zH0IY","label":"style_label__5crRn","labelFloat":"style_labelFloat__6gGUh"};